import { FC } from 'react';
import { Content, isFilled } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';

type Card = Content.LeadCaptureHeroSliceContentFormSplitPrimaryCardsItem;

interface InfoCardProps {
  card: Card;
}

/**
 * Informational card used in the `contentFormSplit` variation: a square icon
 * paired with one or more short lines of text, rendered inside the content
 * column's two-per-row grid.
 */
const InfoCard: FC<InfoCardProps> = ({ card }) => (
  <div className="flex items-center gap-[10px] rounded-[10px] bg-[#F4F4F4] py-[10px] pl-[10px] pr-[20px]">
    {isFilled.image(card.icon) && (
      <PrismicNextImage
        field={card.icon}
        className="h-10 w-10 shrink-0 object-contain"
        alt=""
      />
    )}
    {isFilled.richText(card.content) && (
      <div className="font-inter text-[13px] font-semibold leading-[1.5] text-[#041118]">
        <PrismicRichText
          field={card.content}
          components={{
            paragraph: ({ children }) => <p className="m-0">{children}</p>,
          }}
        />
      </div>
    )}
  </div>
);

export default InfoCard;
